import { useState } from 'react';

export default function ServerIPSection() {
  const [copied, setCopied] = useState(false);
  const serverIP = 'play.furukomc.tr:25633';

  const copyToClipboard = () => {
    navigator.clipboard.writeText(serverIP);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const steps = [
    'Minecraft Java Edition\'ı Aç',
    '"Çok Oyunculu" seçeneğine tıkla',
    'IP\'miz ile Sunucu Ekle',
    'Katıl ve oynamaya başla!',
  ];

  return (
    <section id="server-ip" className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Side - Image */}
          <div className="lg:col-span-3">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-cyan-500/20 border border-cyan-400/30">
              <img
                src="https://public.readdy.ai/ai/img_res/099ee4054c33406f251b5756c089b220.jpg"
                alt="Server Spawn"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
          </div>

          {/* Right Side - Connection Info */}
          <div className="lg:col-span-2">
            <div className="inline-block px-4 py-2 bg-pink-500/20 rounded-full mb-4">
              <span className="text-pink-400 font-bold text-sm uppercase tracking-wider">Başlayın</span>
            </div>
            <h2 className="text-5xl font-black text-white mb-8">
              Sunucumuza Katıl
            </h2>

            {/* IP Box */}
            <div className="bg-black/40 backdrop-blur-md rounded-2xl p-6 border-2 border-cyan-400/50 mb-8">
              <div className="flex items-center justify-between gap-4">
                <div>
                  <p className="text-gray-400 text-sm mb-1">Sunucu IP Adresi</p>
                  <p className="text-cyan-400 font-mono text-2xl font-bold">{serverIP}</p>
                </div>
                <button
                  onClick={copyToClipboard}
                  className="px-4 py-2 bg-cyan-400/20 hover:bg-cyan-400/30 text-cyan-400 rounded-lg transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} text-xl`}></i>
                </button>
              </div>
            </div>

            {copied && (
              <div className="mb-4 text-lime-400 font-semibold text-center animate-pulse">
                ✓ IP Başarıyla Kopyalandı!
              </div>
            )}

            {/* Steps */}
            <div className="space-y-4 mb-8">
              {steps.map((step, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-8 h-8 rounded-full bg-gradient-to-br from-cyan-400 to-blue-500 flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-sm">{index + 1}</span>
                  </div>
                  <p className="text-gray-300 pt-1">{step}</p>
                </div>
              ))}
            </div>

            {/* Copy Button */}
            <button
              onClick={copyToClipboard}
              className="w-full px-8 py-4 bg-gradient-to-r from-cyan-400 to-blue-500 hover:from-cyan-500 hover:to-blue-600 text-white rounded-full font-bold text-lg transition-all hover:scale-105 hover:shadow-2xl hover:shadow-cyan-400/50 whitespace-nowrap cursor-pointer"
            >
              IP Adresini Kopyala
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
